import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RadioInput, TextInput } from "../../../../../components/inputs";

const ArtificialNutritionForm = () => {
  const isJoint = useSelector((state) => state?.instruction?.isJoint);
  const arr = useSelector((state) => state?.instruction?.arr);
  const [edit, setEdit] = useState(arr.length > 1 ? [false, false] : [false]);
  const { yes_no_lookupType: yes_no_lookup } = useSelector(
    (state) => state?.lookupData
  );

  const handleEdit = (clientNumber, value) => {
    setEdit((prev) => {
      let temp = prev;
      temp[clientNumber] = value;
      return [...temp];
    });
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          style={{ fontSize: "bold", marginBottom: "0.5rem" }}
        >
          Artificial Nutrition
        </Typography>
      </Grid>
      <Grid width={"100%"} display={"flex"} flexDirection={"row"}>
        {arr?.map((item, index) => {
          return (
            <Grid
              width={isJoint ? "50%" : "100%"}
              borderTop={`1px solid #DCDCE1`}
              borderBottom={`1px solid #DCDCE1`}
              borderRight={index === 0 ? `1px solid #DCDCE1` : null}
              paddingY={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
              paddingRight={index === 0 ? 2 : 0}
              paddingLeft={index === 1 ? 2 : 0}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <RadioInput
                    orientation="row"
                    label={`Would the Testator like to REFUSE artificial nutrition and hydration intravenously or through a tube if they become permanently unresponsive, terminally ill or injured?`}
                    name={`InstructionLivingWillQuestionnaire.[${index}].artificialNutrition.isRefuseNutritionTreatment`}
                    options={yes_no_lookup}
                  />
                </Grid>

                <Grid item xs={12} pr={1}>
                  <TextInput
                    label={`Mention the scenario`}
                    name={`InstructionLivingWillQuestionnaire.[${index}].artificialNutrition.scenario`}
                    placeholder="Mention the scenario"
                  />
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default ArtificialNutritionForm;
